// extracted by mini-css-extract-plugin
export default {"text":"packageRoomInfo-module__text__EvGxR","link":"packageRoomInfo-module__link__P13qs"};